/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約共通情報
 */
export interface Szma301aResCtrCommonInfoDto {
    /**
     * 会社グループコード
     */
    companygroupcode?: string;
    /**
     * 会社コード
     */
    companycode?: string;
    /**
     * 地区コード
     */
    areacode?: string;
    /**
     * 受付番号
     */
    aceptNo?: string;
    /**
     * 基本契約書番号
     */
    basiccontractdocumentNo?: string;
    /**
     * 基本契約年数
     */
    basiccontractNumberofyears?: string;
    /**
     * 初回検針年月
     */
    firstInspectionyearmonthday?: string;
    /**
     * ＷＴ卸契約種別コード
     */
    wtoroshiContractclassfyCode?: string;
    /**
     * 契約書番号
     */
    ctrdocNo?: string;
    /**
     * 基本契約締結日付
     */
    basiccontractConclusiondate?: string;
    /**
     * 基本契約書受領日付
     */
    basiccontractdocumentReceiptdate?: string;
    /**
     * 基本契約適用開始日付
     */
    basiccontractEffectivestartdate?: string;
    /**
     * 契約書受領日
     */
    ctrdocReceiptdate?: string;
    /**
     * 延滞利息対象フラグ
     */
    dryrskTargetflag?: string;
    /**
     * 延滞利息対象フラグ名称
     */
    dryrskTargetflagAname?: string;
    /**
     * 契約無効フラグ
     */
    ctrInvalidflag?: string;
    /**
     * 契約無効フラグ名称
     */
    ctrInvalidflagAname?: string;
    /**
     * 独自管理対象個別コード
     */
    independentmanagementTargetIndividualcode?: string;
    /**
     * 停止時要配慮フラグ
     */
    duringstopAttentionrequiredflag?: string;
    /**
     * 停止時要配慮フラグ名称
     */
    duringstopAttentionrequiredflagAname?: string;
    /**
     * 免税種類コード
     */
    exmptaxSyuruicode?: string;
    /**
     * 免税種類コード名称
     */
    exmptaxsyuruiCodeaname?: string;
    /**
     * 同一地点キー
     */
    sameLocationkey?: string;
    /**
     * お客さま契約窓口担当部署
     */
    visitMadoguchiTantobusho?: string;
    /**
     * お客さま契約窓口担当者
     */
    visitMadoguchiTntsh?: string;
    /**
     * お客さま契約窓口電話番号
     */
    visitMadoguchiTelno?: string;
    /**
     * 調整単位料金おしらせ発行フラグ
     */
    adjustmentunitfeeNoticeHakkoflag?: string;
    /**
     * 調整単位料金おしらせ発行フラグ名称
     */
    adjustmentunitfeeNoticeHakkoflagAname?: string;
    /**
     * 契約担当組織番号
     */
    ctrTantoSskno?: string;
    /**
     * 担当個人ＩＤ
     */
    tantoPrivateid?: string;
    /**
     * 選択約款開始日付
     */
    selectykknStrtdate?: string;
    /**
     * 契約履歴フラグ
     */
    ctrRrkFlg?: string;
    /**
     * 契約履歴フラグ名称
     */
    ctrRrkAname?: string;
    /**
     * 供給地点特定番号
     */
    suppntSpno?: string;
    /**
     * 使用需要者区分
     */
    usingJuyoshaDiv?: string;
    /**
     * 使用需要者区分名称
     */
    usingjyuyoshaDivaname?: string;
    /**
     * 使用者お客さま漢字氏名
     */
    userName?: string;
    /**
     * 使用者お客さまカナ氏名
     */
    userKanaName?: string;
    /**
     * 使用者お客さま電話番号コード１
     */
    userTeldv1?: string;
    /**
     * 使用者お客さま電話番号コード１名称
     */
    userTeldv1Aname?: string;
    /**
     * 使用者お客さま電話番号１
     */
    userTelNo1?: string;
    /**
     * 使用者お客さま電話番号コード２
     */
    userTeldv2?: string;
    /**
     * 使用者お客さま電話番号コード２名称
     */
    userTeldv2Aname?: string;
    /**
     * 使用者お客さま電話番号２
     */
    userTelNo2?: string;
    /**
     * 使用者お客さま電話番号コード３
     */
    userTeldv3?: string;
    /**
     * 使用者お客さま電話番号コード３名称
     */
    userTeldv3Aname?: string;
    /**
     * 使用者お客さま電話番号３
     */
    userTelNo3?: string;
    /**
     * 住所コード
     */
    addressCode?: string;
    /**
     * 郵便番号
     */
    postno?: string;
    /**
     * 都道府県名称
     */
    pfcAname?: string;
    /**
     * 都道府県カナ名称
     */
    prefecturesNameKana?: string;
    /**
     * 市区郡町村名称
     */
    mptAname?: string;
    /**
     * 市区郡町村カナ名称
     */
    visitMptKanaAname?: string;
    /**
     * 町域名称
     */
    townAreaName?: string;
    /**
     * 町域カナ名称
     */
    townAreaNameKana?: string;
    /**
     * 大字丁目名称
     */
    ooazaName?: string;
    /**
     * 大字丁目カナ名称
     */
    visitOazaKanaAname?: string;
    /**
     * 番地・号・分筆号
     */
    blockgoulot?: string;
    /**
     * 住宅・棟号漢字名
     */
    visitSupadrAname?: string;
    /**
     * 住宅・棟号カナ名
     */
    visitSupadrKananm?: string;
    /**
     * 屋号・業種漢字名
     */
    visitYagouAname?: string;
    /**
     * 屋号・業種カナ名
     */
    visitYagouKananm?: string;
    /**
     * 表示住所漢字
     */
    empposAddrAnameF?: string;
    /**
     * 表示住所カナ
     */
    empposAddrKanaAnameF?: string;
    /**
     * 署名区分
     */
    signatureDiv?: string;
    /**
     * 販売契約書ファイルパス
     */
    salescontractdocumentFilepath?: string;
    /**
     * 更新通番号：数字
     */
    updateSrno?: string;
}

